export const spaceName = 'odDishTypes';

export interface DishTypeSettings {
  showDrawer: {
    show: boolean;
    key?: 'create';
  };
  // for batch action
  selectedIds: Number[];
  currentPageInfo: {
    data: any[];
    params: {
      currentPage: Number;
      pageSize: Number;
      total: Number;
    };
  };
}

export default {
  showDrawer: {
    show: false,
  },
  selectedIds: [],
  currentPageInfo: {
    data: [],
    params: {
      currentPage: 1,
      pageSize: 12,
      total: 0,
    },
  },
} as DishTypeSettings;
